import Icon from "@mui/material/Icon";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

import DashboardPemohon from "layouts/dashboards/pemohon";
import DashboardPetugas from "layouts/dashboards/petugas";
import DashboardAdmin from "layouts/dashboards/admin";
import DaftarLayanan from "layouts/pages/layanan/daftar-layanan";
import DetailLayanan from "layouts/pages/layanan/detail-layanan";
import DaftarPengajuan from "layouts/pages/pengajuan/daftar-pengajuan";
import DetailPengajuan from "layouts/pages/pengajuan/detail-pengajuan";
import ProfileOverview from "layouts/pages/profile/profile-overview";
import SignInCover from "layouts/authentication/sign-in/cover";
import SignUpCover from "layouts/authentication/sign-up/cover";
import VerifikasiPublik from "layouts/pages/verifikasi/publik";
import AdminJenisIzin from "layouts/pages/admin/jenis-izin";
import AdminUsers from "layouts/pages/admin/users";
import AdminPengaduan from "layouts/pages/admin/pengaduan";
import AdminGaleriAktivitas from "layouts/pages/admin/galeri-aktivitas";
import AdminAsetGambar from "layouts/pages/admin/aset-gambar";
import LandingPage from "layouts/pages/landing";

import { logoutUser } from "actions/AuthAction";
import { getUserData } from "utils/userData";

function LogoutComponent() {
  const navigate = useNavigate();
  useEffect(() => {
    logoutUser(navigate);
  }, [navigate]);
  return null;
}

export function buildRoutes() {
  const { userName, userRole } = getUserData();

  const isPemohon = userRole === "PEMOHON";
  const isSuperAdmin = userRole === "SUPER_ADMIN";
  const isAdmin = userRole === "ADMIN" || isSuperAdmin;
  const isStaff = ["PETUGAS", "VERIFIKATOR", "PIMPINAN", "ADMIN", "SUPER_ADMIN"].includes(userRole);

  return [
  {
    type: "collapse",
    name: userName,
    key: "user-menu",
    available: !!userRole,
    icon: <Icon fontSize="small">account_circle</Icon>,
    collapse: [
      {
        name: "Profil",
        key: "profile",
        route: "/pages/profile/profile-overview",
        component: <ProfileOverview />,
        available: true,
      },
      {
        name: "Keluar",
        key: "logout",
        route: "/logout",
        component: <LogoutComponent />,
        available: true,
      },
    ],
  },
  { type: "divider", key: "divider-0", available: !!userRole },

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    available: isPemohon,
    collapse: [
      {
        name: "Beranda Pemohon",
        key: "dashboard-pemohon",
        route: "/dashboard/pemohon",
        component: <DashboardPemohon />,
        available: true,
      },
    ],
  },

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard-staff",
    icon: <Icon fontSize="small">dashboard</Icon>,
    available: isStaff && !isAdmin,
    collapse: [
      {
        name: "Beranda Petugas",
        key: "dashboard-petugas",
        route: "/dashboard/petugas",
        component: <DashboardPetugas />,
        available: true,
      },
    ],
  },

  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard-admin",
    icon: <Icon fontSize="small">dashboard</Icon>,
    available: isAdmin,
    collapse: [
      {
        name: "Beranda Admin",
        key: "dashboard-admin-home",
        route: "/dashboard/admin",
        component: <DashboardAdmin />,
        available: true,
      },
      {
        name: "Antrian Petugas",
        key: "dashboard-petugas-admin",
        route: "/dashboard/petugas",
        component: <DashboardPetugas />,
        available: true,
      },
    ],
  },

  {
    type: "collapse",
    name: "Layanan",
    key: "layanan",
    icon: <Icon fontSize="small">description</Icon>,
    available: isPemohon,
    collapse: [
      {
        name: "Pilih Layanan",
        key: "daftar-layanan",
        route: "/layanan",
        component: <DaftarLayanan />,
        available: true,
      },
    ],
  },

  {
    type: "collapse",
    name: "Pengajuan",
    key: "pengajuan",
    icon: <Icon fontSize="small">assignment</Icon>,
    available: !!userRole,
    collapse: [
      {
        name: isPemohon ? "Pengajuan Saya" : "Daftar Pengajuan",
        key: "daftar-pengajuan",
        route: "/pengajuan",
        component: <DaftarPengajuan />,
        available: true,
      },
    ],
  },

  {
    type: "collapse",
    name: "Administrasi",
    key: "admin",
    icon: <Icon fontSize="small">admin_panel_settings</Icon>,
    available: isAdmin,
    collapse: [
      {
        name: "Jenis Izin",
        key: "admin-jenis-izin",
        route: "/admin/jenis-izin",
        component: <AdminJenisIzin />,
        available: true,
      },
      {
        name: "Pengguna Staff",
        key: "admin-users",
        route: "/admin/users",
        component: <AdminUsers />,
        available: isSuperAdmin,
      },
      {
        name: "Pengaduan",
        key: "admin-pengaduan",
        route: "/admin/pengaduan",
        component: <AdminPengaduan />,
        available: true,
      },
      {
        name: "Galeri Aktivitas",
        key: "admin-galeri",
        route: "/admin/galeri-aktivitas",
        component: <AdminGaleriAktivitas />,
        available: true,
      },
      {
        name: "Aset Gambar",
        key: "admin-aset-gambar",
        route: "/admin/aset-gambar",
        component: <AdminAsetGambar />,
        available: true,
      },
    ],
  },
  ];
}

export const landingPageRoute = {
  route: "/",
  component: <LandingPage />,
};

export const signInCoverRoute = {
  route: "/authentication/sign-in/cover",
  component: <SignInCover />,
};

export const signUpCoverRoute = {
  route: "/authentication/sign-up/cover",
  component: <SignUpCover />,
};

export const detailLayananRoute = {
  route: "/layanan/:id",
  component: <DetailLayanan />,
};

export const detailPengajuanRoute = {
  route: "/pengajuan/:id",
  component: <DetailPengajuan />,
};

export const verifikasiPublikRoute = {
  route: "/verifikasi/:kode",
  component: <VerifikasiPublik />,
};

export default buildRoutes;
